@if (shoppingList()) {
  <ui-shopping-list-header
    (editShoppingListNameClicked)="editShoppingListName()"
    [shoppingList]="shoppingList()"
    [items]="items()"
  ></ui-shopping-list-header>
}

<div class="wrapper-shopping-list">
  @if (!isMobile()) {
    <div class="shopping-list-quick-add">
      <ng-container *ngTemplateOutlet="addToShoppingListQuick"></ng-container>
    </div>
  }
  <div class="product-list">
    @if (isLoading()) {
      <!-- implement skeleton here -->
    } @else if (error()) {
      <ui-alert
        theme="error"
        message="Es ist ein Fehler beim laden der Einkaufsliste-Liste aufgetreten bitte versuchen Sie es erneut">
      </ui-alert>
    } @else {
      <ui-shopping-list-items
        [items]="items()"
        (itemQuantityChanged)="onItemQuantityChanged($event)"
        (itemsRemoved)="onRemoveItems($event)"
        (itemsAddToCart)="onItemsAddToCart($event)"
        (openAddToShoppingListQuickMobile)="openAddToShoppingListQuick()"
        (openScanner)="openScanner()"
        (download)="download()"
        [isDownloading]="isDownloading()"
      >
      </ui-shopping-list-items>
    }
  </div>
</div>

<ui-create-and-edit-shopping-list-dialog
  [shoppingListToEdit]="shoppingList()">
</ui-create-and-edit-shopping-list-dialog>

<ng-template #addToShoppingListQuick>
  <ui-add-to-shopping-list-quick
    (productSelected)="addProductToShoppingListQuick($event)"
    [isDialogView]="isMobile()">
  </ui-add-to-shopping-list-quick>
</ng-template>
